import axios from 'axios'

export default axios.create({
    baseURL: 'https://lpn-backend.lpn.co.th/api/SVEA'
    // baseURL: 'http://127.0.0.1:8000/api/SVEA'
})

// axios.interceptors.response.use((response) => {
//     return response;
// }, function (error) {
//     // Do something with response error
//     console.log(error)
//     if (error.response.status === 401) {
//         console.log('unauthorized, logging out ...');
//         this.logout()
//         router.replace('/login');
//     }
//     return Promise.reject(error.response);
// })




// axios.interceptors.response.use((response) => { // intercept the global error
//     return response
// }, function (error) {
//     console.log("has expire")
//     let originalRequest = error.config
//     if (error.response.status === 401 && !originalRequest._retry) { // if the error is 401 and hasent already been retried
//         originalRequest._retry = true // now it can be retried
//         return Vue.axios.post('/users/token', null).then((data) => {
//             store.dispatch('authfalse')
//             store.dispatch('authtruth', data.data)
//             originalRequest.headers['Authorization'] = 'Bearer ' + store.state.token // new header new token
//             return Vue.axios(originalRequest) // retry the request that errored out
//         }).catch((error) => {
//             for (let i = 0; i < error.response.data.errors.length; i++) {
//                 if (error.response.data.errors[i] === 'TOKEN-EXPIRED') {
//                     auth.logout()
//                     return
//                 }
//             }
//         })
//     }
//     if (error.response.status === 404 && !originalRequest._retry) {
//         originalRequest._retry = true
//         window.location.href = '/'
//         return
//     }
//     // Do something with response error
//     return Promise.reject(error)
// })